module.exports = __webpack_public_path__ + "static/media/news-img.9e19131d.png";